import script from "./CreateEventV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateEventV2.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__